import React, { useState } from 'react'
import styled from 'styled-components';
import { useHistory } from 'react-router-dom'

import SVGIcon from '../../services/SVGIcon';
import { Footer, Card, Logo } from '../../components';
import { TextInput, Button, Toast, Loader, Content } from '@checkplant/soil';
import { requestPassword, sendNewPassword } from '../../services/user';

const Password = () => {
  const history = useHistory();
  const token = new URLSearchParams(history.location.search).get("token")

  const [user, setUser] = useState({});
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState({ type: 'error', icon: 'fa-times' });
  const [sending, setSending] = useState(false);

  const _onHandleChange = e => setUser({ ...user, [e.target.name]: e.target.value })
  const backNavigation = () => window.history.back();

  const getError = e => {
    setSending(false);

    const { errors, error } = e.response.data;
    if (errors)
    Object.keys(errors).map(e => setMessages(errors[e]))
    else if (error)
    setMessages([error])
    else
    setMessages(['Ocorreu um erro, tente novamente.'])
  }

  const _onSubmit = e => {
    e.preventDefault();
    setMessages([]);

    token ? _sendPasswordRecovery() : _requestPasswordRecovery();
  }

  const _requestPasswordRecovery = () => {
    if (user.username) {
      setSending(true)

      requestPassword({ user: { ...user, commit: 'Enviar as instruções por e-mails' } }).then(() => {
        setStatus({ type: 'success', icon: 'fa-check' });
        setMessages(['Dentro de alguns minutos você irá receber um e-mail']);
        setSending(false)
      }).catch(getError)
    } else {
      setMessages(['Usuário inválido']);
    }
  }

  const _sendPasswordRecovery = () => {
    if (user.confirm_password && user.password) {
      if (user.confirm_password === user.password) {
        setSending(true)

        sendNewPassword({
          user: { ...user, reset_password_token: token, commit: 'Mudar a senha' }
        }).then(() => {
          setSending(false)
          history.push('/front/recovered');
        }).catch(e => getError(e));
      } else {
        setMessages(['A nova senha e a confirmação precisam ser iguais']);
      }
    } else {
      setMessages(['A nova senha e a confirmação não podem ficar em branco']);
    }
  }

  return (
    <>
      <Loader 
        isLoading={sending}
      />
      <Content>
        <Card>
          <Logo>
            <SVGIcon
              width="149"
              height="48"
              name={'farmbox-logo-with-writes'}
              fill={'none'} />
          </Logo>
          <form onSubmit={_onSubmit}>
            <div className="flex justify-content-center">
              <span className="font-soil h2 mt-8 mb-8">Esqueci a senha</span>
            </div>

            <Toast
              errors={messages}
              type={status.type}
              icon={status.icon}
              style={{ position: 'initial', height: '100%' }} />

            {
              token ? 
              <>
                <TextInput
                  name="password"
                  label="Nova Senha"
                  type="password"
                  onChange={_onHandleChange}
                  style={{ marginTop: "16px" }}
                />
                <TextInput
                  name="confirm_password"
                  label="Confirmação de Senha"
                  type="password"
                  onChange={_onHandleChange}
                  style={{ marginTop: "16px" }}
                />
              </>
             : 
              <>
                <TextInput
                  name="username"
                  label="Usuário"
                  type="text"
                  onChange={_onHandleChange}
                  style={{ marginTop: "12px" }}
                />
                <div className="flex">
                  <span className="font-soil information" style={{ color: '#798AA4' }}>Você receberá um email com as instruções.</span>
                </div>
              </>
            }

            <ButtonSubmit theme="regular" children={token ? "Cadastrar nova senha" : "Recuperar a senha"} btnType='submit' />
          </form>
          <div className="flex justify-content-center mt-8">
            <Button theme="minor" children="Cancelar" onClick={backNavigation} />
          </div>
        </Card>
      </Content>
      <Footer>
        <SVGIcon name={'farmbox-logo-footer'} fill={'none'} width="110" height="32" />
      </Footer>
    </>
  )
}

const ButtonSubmit = styled(Button)`
  width: 100%;
  margin-top: 16px;

  display: center;
  justify-content: center;
`;

export default Password;
